module.exports = __webpack_public_path__ + "static/media/JacobSiebach.f9654b5e.jpeg";